import MasterLayout from '@views/layouts/MasterLayout';
import AuthLayout from '@views/layouts/AuthLayout';

/**
 * Every route becomes a chunk, loaded only when used.
 * Reduces size of initial App load.
 */
const routes = [

    {
        path: '/login',
        redirect: 'login',
        component: AuthLayout,
        children: [
                {
                    name: 'login',
                    path: '/login',
                    component: () => import( /* webpackChunkName: "chunks/login" */ '@views/Login')
                },
                {
                    name: 'reset-password',
                    path: '/reset-password',
                    component: () => import( /* webpackChunkName: "chunks/forget-password" */ '@views/ForgetPassword'),

                },
                {
                    path: '/reset-password/:token',
                    name: 'reset-password-form',
                    component: () => import( /* webpackChunkName: "chunks/reset-password-form" */ '@views/ResetPasswordForm'),
                }
            ]
    },

    {
        path: '/',
        redirect: 'dashboard',
        component: MasterLayout,
        children: [{
                name: 'dashboard',
                path: '/',
                component: () => import( /* webpackChunkName: "chunks/dashboard" */ '@views/Dashboard'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'grades',
                path: '/grades',
                component: () => import( /* webpackChunkName: "chunks/grades" */ '@views/grades/GradesList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'classes',
                path: '/classes',
                component: () => import( /* webpackChunkName: "chunks/classes" */ '@views/classes/ClassesList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'subjects',
                path: '/subjects',
                component: () => import( /* webpackChunkName: "chunks/subjects" */ '@views/subjects/SubjectsList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'classrooms',
                path: '/classrooms',
                component: () => import( /* webpackChunkName: "chunks/classrooms" */ '@views/classrooms/ClassroomsList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'schools',
                path: '/schools',
                component: () => import( /* webpackChunkName: "chunks/schools" */ '@views/schools/SchoolsList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'teachers',
                path: '/teachers',
                component: () => import( /* webpackChunkName: "chunks/teachers" */ '@views/teachers/TeachersList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'roles',
                path: '/roles',
                component: () => import( /* webpackChunkName: "chunks/roles" */ '@views/roles/RolesList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'users',
                path: '/users',
                component: () => import( /* webpackChunkName: "chunks/users" */ '@views/users/UsersList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'students',
                path: '/students',
                component: () => import( /* webpackChunkName: "chunks/students" */ '@views/students/UsersList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'parents',
                path: '/parents',
                component: () => import( /* webpackChunkName: "chunks/parents" */ '@views/parents/UsersList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'notifications',
                path: '/notifications',
                component: () => import( /* webpackChunkName: "chunks/notifications" */ '@views/notifications/NotificationsList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'weekly-plans',
                path: '/weekly-plans',
                component: () => import( /* webpackChunkName: "chunks/weekly-plans" */ '@views/weekly_plans/WeeklyPlansList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'time-tables',
                path: '/time-tables',
                component: () => import( /* webpackChunkName: "chunks/time-tables" */ '@views/time_tables/TimeTablesList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'worksheets',
                path: '/worksheets',
                component: () => import( /* webpackChunkName: "chunks/worksheets" */ '@views/worksheets/WorksheetsList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'exams',
                path: '/exams',
                component: () => import( /* webpackChunkName: "chunks/worksheets" */ '@views/exams/ExamList'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'profile',
                path: '/profile',
                component: () => import( /* webpackChunkName: "chunks/worksheets" */ '@views/users/UserProfile'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                name: 'messages',
                path: '/messages',
                component: () => import( /* webpackChunkName: "chunks/albums" */ '@views/messages/MessagesList'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    }
]
export default routes
